import RestService from './RestService'

export default class SiteService extends RestService {
    constructor() {
        super('websites')
    }

    checkDns(websiteId) {
        let url = this.baseUrl + '/api/v1/check-dns/' + websiteId + '.json?t=' + Date.now()
        return new Promise((resolve, reject) => {
            this.http.get(url)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {
                    if (response.status === 200 || response.status === 201) {
                        resolve(JSON.parse(response.text))
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }

    // GET /api/v1/websites/:id/copy-template-pages/:template_id
    copyPages(websiteId, websiteTemplateId) {
        let url = this.baseUrl + '/api/v1/websites/' + websiteId + '/copy-template-pages/' + websiteTemplateId + '.json?t=' + Date.now()
        return new Promise((resolve, reject) => {
            this.http.get(url)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {
                    if (response.status === 200 || response.status === 201) {
                        resolve(JSON.parse(response.text))
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }

    deploySite(websiteId) {
        let url = this.baseUrl + '/api/v1/deploy-site/' + websiteId + '.json?t=' + Date.now()
        return new Promise((resolve, reject) => {
            this.http.get(url)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {
                    if (response.status === 200 || response.status === 201) {
                        resolve(JSON.parse(response.text))
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }
}